export enum ProductSegment {
  // Carlyle AccountSummary
  CorporateAccountSummary = "Corporate:AccountSummary",
  GlobalCreditAccountSummary = "Global Credit:AccountSummary",
  GlobalPrivateEquityAccountSummary = "Global Private Equity:AccountSummary",

  // Carlyle Reports
  CorporateReports = "Corporate:Reports",
  GlobalCreditReports = "Global Credit:Reports",
  GlobalPrivateEquityReports = "Global Private Equity:Reports",

  // Funds
  CorporateFunds = "Corporate:Funds",
  GlobalCreditFunds = "Global Credit:Funds",
  GlobalPrivateEquityFunds = "Global Private Equity:Funds",

  // Data Rooms
  CorporateDataRooms = "Corporate:NewOpportunities",
  GlobalCreditDataRooms = "Global Credit:NewOpportunities",
  GlobalPrivateEquityDataRooms = "Global Private Equity:NewOpportunities",
  InvestmentSolutionsDataRooms = "Carlyle AlpInvest:NewOpportunities",

  // AlpInvest AccountSummary
  InvestmentSolutionsAccountSummary = "Carlyle AlpInvest:AccountSummary",
  InvestmentSolutionsAccountSummaryExport = "Carlyle AlpInvest:AccountSummaryExport",

  // AlpInvest PortfolioPerformance Report
  InvestmentSolutionsPortfolioPerformance = "Carlyle AlpInvest:PortfolioPerformance",
  InvestmentSolutionsPortfolioPerformanceExport = "Carlyle AlpInvest:PortfolioPerformanceExport",

  // AlpInvest DiversificationAnalysis Report
  InvestmentSolutionsDiversificationAnalysis = "Carlyle AlpInvest:DiversificationAnalysis",
  InvestmentSolutionsDiversificationAnalysisExport = "Carlyle AlpInvest:DiversificationAnalysisExport",

  // AlpInvest Demo User
  DemoUser = "Carlyle AlpInvest:Demo",

  // AlpInvest Admin
  AlpInvestAdmin = "Carlyle AlpInvest:Admin",
}
